import { cloneData } from '@ui-furniture/lib/utils/clone-data';

import { DataStore } from './data-store';

import { CreateMemento } from '../memento/types/create-memento';

export class DataStoreMementoCreator<TData extends object> {
  constructor(private _dataStore: DataStore<TData>) {}

  createMemento: CreateMemento = () => {
    // Clone data otherwise arrays can get modified
    const savedData = cloneData(this._dataStore.getData());
    return {
      restore: () => {
        this._dataStore.setData(savedData);
      },
    };
  };
}
